import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone } from 'lucide-react';
import { Logo } from './Logo';

export const Footer = () => {
  const footerLinks = {
    'Solutions': [
      { label: 'Achat Local', href: '#app' },
      { label: 'Commerce International', href: '#app' },
      { label: 'Livraison Repas', href: '#app' },
      { label: 'Pharmacie Drive', href: '#app' },
      { label: 'Syne Drive', href: '#app' },
    ],
    'Services': [
      { label: 'Stratégie & Consulting', href: '#services' },
      { label: 'Expérience Utilisateur', href: '#services' },
      { label: 'Data Intelligence', href: '#services' },
      { label: 'Développement', href: '#services' },
    ],
    'Entreprise': [
      { label: 'À propos', href: '#about' },
      { label: 'Tarifs', href: '#pricing' },
      { label: 'Contact', href: '#contact' },
      { label: 'Carrières', href: '#' },
    ],
    'Légal': [
      { label: 'Conditions d\'utilisation', href: '#' },
      { label: 'Politique de confidentialité', href: '#' },
      { label: 'Mentions légales', href: '#' },
      { label: 'RGPD', href: '#' },
    ],
  };

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
  ];

  return (
    <footer className="bg-secondary text-secondary-foreground">
      <div className="container">
        {/* Main Footer Content */}
        <div className="py-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {/* Brand Column */}
          <div className="col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <Logo className="w-12 h-12" />
              <div className="flex flex-col">
                <span className="text-xl font-display font-bold leading-none">
                  Open <span className="text-primary">Syne</span>
                </span>
                <span className="text-xs text-secondary-foreground/70">E-commerce Solutions</span>
              </div>
            </div>
            <p className="text-sm text-secondary-foreground/70 mb-6 max-w-xs">
              Transformez votre commerce avec la plateforme e-commerce leader au Bénin. Innovation, performance et accompagnement sur mesure.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    aria-label={social.label}
                    className="w-10 h-10 bg-secondary-foreground/10 rounded-lg flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-all duration-300 group"
                  >
                    <Icon size={18} className="group-hover:scale-110 transition-transform" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="font-display font-semibold mb-4 text-primary">{title}</h3>
              <ul className="space-y-2">
                {links.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.href}
                      className="text-sm text-secondary-foreground/70 hover:text-primary transition-colors duration-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-secondary-foreground/10 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-secondary-foreground/60 text-center md:text-left">
              © {new Date().getFullYear()} Open Syne. Tous droits réservés.
            </p>
            <div className="flex items-center gap-6 text-sm text-secondary-foreground/60">
              <a href="mailto:contact@syneopen.com" className="flex items-center gap-2 hover:text-primary transition-colors">
                <Mail size={16} />
                contact@syneopen.com
              </a>
              <a href="tel:+22901563920999" className="flex items-center gap-2 hover:text-primary transition-colors">
                <Phone size={16} />
                +229 01 56 39 20 99
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};